import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import AftercareApplicationCard from './AftercareApplicationCard';

const AftercareApplicationCards = ({ list, handleOpenAftercareApp }) => {
  return (
    <>
      <Grid container direction="row">
        {list &&
          list.map((r) => {
            return (
              <Grid item xs={12} sm={6} md={4} key={r.id}>
                <AftercareApplicationCard request={r} handleOpenAftercareApp={handleOpenAftercareApp} />
              </Grid>
            );
          })}
      </Grid>
    </>
  );
};

AftercareApplicationCards.propTypes = {
  list: PropTypes.array.isRequired,
  handleOpenAftercareApp: PropTypes.func.isRequired,
};

export default AftercareApplicationCards;
